import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import WebsiteItem from './WebsiteItem';

const Websites = ({ className, websites, showActive = false }) => {
    const activeID = useSelector(state =>
        state.license.active.ID ? state.license.active.ID : null
    );

    const generateWebsite = website => {
        return (
            <WebsiteItem
                key={website.ID}
                id={website.ID}
                url={website.sites[0]}
                active={activeID === website.ID}
            />
        );
    };

    return !activeID || showActive ? (
        <div className={className}>
            {websites.length ? (
                <>
                    <span>وب سایت های شما :</span>
                    {websites.map(generateWebsite)}
                </>
            ) : (
                <span> وب سایتی موجود نمی باشد</span>
            )}
        </div>
    ) : null;
};

Websites.defaultProps = {
    showActive: false
};

Websites.propTypes = {
    className: PropTypes.string.isRequired,
    websites: PropTypes.arrayOf(
        PropTypes.shape({
            ID: PropTypes.number.isRequired
        })
    ).isRequired,
    showActive: PropTypes.bool
};

export default styled(Websites)`
    width: 100%;
    display: flex;
    flex-flow: column wrap;
    align-items: center;

    > span {
        margin-bottom: 1em;
    }
`;
